'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getEncodedMonthData = exports.getEncodedDateData = exports.getDecodedMonthData = exports.getDecodedDateData = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _ramda = require('ramda');

var _dateFns = require('date-fns');

var getDecodedDateData = exports.getDecodedDateData = function getDecodedDateData(value) {
    try {
        var valueString = '' + (value || '');

        if (valueString.indexOf('/') > -1) {
            var day = +valueString.slice(0, 2);
            var month = +valueString.slice(3, 5) - 1;
            var year = +valueString.slice(6, 10);

            return {
                day: day, month: month, year: year
            };
        } else {
            var _year = +valueString.slice(0, 4);
            var _month = +valueString.slice(4, 6) - 1;
            var _day = +valueString.slice(6);
            return {
                day: _day, month: _month, year: _year
            };
        }
    } catch (err) {
        return { day: '', month: '', year: '' };
    }
};

var getDecodedMonthData = exports.getDecodedMonthData = function getDecodedMonthData(value) {
    try {
        var valueString = '' + (value || '');

        if (valueString.indexOf('/') > -1) {
            var month = +value.slice(0, 2) - 1;
            var year = +value.slice(3, 7);

            return {
                month: month, year: year
            };
        } else {
            var _year2 = +value.slice(0, 4);
            var _month2 = +value.slice(4) - 1;

            return {
                month: _month2, year: _year2
            };
        }
    } catch (err) {
        return { month: '', year: '' };
    }
};

var getEncodedDateData = exports.getEncodedDateData = function getEncodedDateData(value) {
    return value && (0, _ramda.all)(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            value = _ref2[1];

        return !(0, _ramda.isNil)(value);
    }, (0, _ramda.toPairs)(value)) ? [(0, _dateFns.format)(new Date(value.year, value.month, value.day), 'DD/MM/YYYY')] : null;
};

var getEncodedMonthData = exports.getEncodedMonthData = function getEncodedMonthData(value) {
    return value && (0, _ramda.all)(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            value = _ref4[1];

        return !(0, _ramda.isNil)(value);
    }, (0, _ramda.toPairs)(value)) ? [(0, _dateFns.format)(new Date(value.year, value.month), 'MM/YYYY')] : null;
};